/**
 * Fills all [data-duals-viewed] badges with a stable per-product daily count.
 *
 * Skewed distribution (more realistic than a flat 8–47 range):
 *   ~70% quiet     →  5–34
 *   ~20% popular   → 40–95
 *   ~8%  hot       → 110–240
 *   ~2%  outliers  → 280–520
 *
 * Same product + UTC day → same number.
 */
(function () {
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function inRange(seed, min, max) {
    return min + (seed % (max - min + 1));
  }

  function countFor(productId) {
    var dayBucket = Math.floor(Date.now() / 86400000);
    var seed = hash(String(productId) + ':' + String(dayBucket));
    // Separate stream so tier pick isn't correlated with the count within-tier
    var tierSeed = hash(String(productId) + ':tier:' + String(dayBucket));
    var roll = tierSeed % 100;

    if (roll < 70) return inRange(seed, 5, 34); // quiet
    if (roll < 90) return inRange(seed, 40, 95); // popular
    if (roll < 98) return inRange(seed, 110, 240); // hot
    return inRange(seed, 280, 520); // rare outlier
  }

  function fill(root) {
    if (!root || root.getAttribute('data-duals-viewed-filled') === '1') return;
    var productId = root.getAttribute('data-product-id');
    if (!productId) return;
    var numEl = root.querySelector('.duals-viewed-count__num');
    if (!numEl) return;
    numEl.textContent = String(countFor(productId));
    root.setAttribute('data-duals-viewed-filled', '1');
  }

  function fillAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-duals-viewed]');
    for (var i = 0; i < roots.length; i++) fill(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fillAll();
    });
  } else {
    fillAll();
  }

  document.addEventListener('shopify:section:load', function () {
    fillAll();
  });

  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-duals-viewed]')) fill(n);
          else if (n.querySelectorAll) fillAll(n);
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
